import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import { CustomerOrLogin } from '@olo-web/components/molecules/CustomerOrLogin';
import { MenuHeaderLogo, useMenuHeader } from '@templates/Menu/MenuHeader/common';
import { OrderingUnavailableHeaderDetails } from './OrderingUnavailableHeaderDetails.ui';
import { Card } from '@olo-web/components/atoms/Card';
import { useMerchantDisplayName, useMerchantImages } from '@domain/merchants/hooks';

const SP = 2;

export const OrderingUnavailableHeaderMobile = () => {
  const { bg } = useMenuHeader();
  const { logoUrl } = useMerchantImages();
  const merchantName = useMerchantDisplayName();

  return (
    <Flex
      flexDir="column"
      w="100%"
      pos="relative"
      justify="stretch"
      align="stretch"
      overflow="hidden"
    >
      <Flex
        justify="center"
        align="center"
        flexDir="column"
        pt="calc(8px + env(safe-area-inset-top))"
        {...bg}
      >
        <Box pos="relative" w="100%" textAlign="right" mb="-44px" zIndex="2">
          <CustomerOrLogin
            buttonProps={{ colorScheme: 'whiteAlpha' }}
            avatarMenuButtonProps={{ mt: 2, mr: 3, color: 'white' }}
            avatarProps={{ bg: 'whiteAlpha.900', color: 'blackAlpha.900' }}
          />
        </Box>
        <MenuHeaderLogo src={logoUrl} mt={SP * 5} mb={SP} />
        <Text
          as="h1"
          textStyle="h2"
          color="white"
          mb={SP}
          mt={logoUrl ? SP : SP * 4}
          px={2}
          textAlign="center"
          lineHeight="28px"
        >
          {merchantName}
        </Text>
        <Card id="header-card" m={SP} px={0} pt={3} pb={1} zIndex={1} w="calc(100% - 2rem)">
          <OrderingUnavailableHeaderDetails />
        </Card>
        <Box h="36px" mt="-40px" w="103%" bgColor="#F7F7FA" borderRadius="300px 300px 0 0" />
      </Flex>
    </Flex>
  );
};
